import React from 'react';

const NavigationTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', label: '🏠 Home' },
    { id: 'jobDefinition', label: '📋 Job Definition' },
    { id: 'cvUpload', label: '📤 CV Upload & Listing' },
    { id: 'questions', label: '❓ Interview Questions' },
    { id: 'agent', label: '🤖 AI Agent' }
  ];

  return (
    <div className="navigation-tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default NavigationTabs;
